var $e1819c2136902bf7$exports = {};
$e1819c2136902bf7$exports = {
  "backButton": args => "".concat(args.prevMenuButton, "(\uC73C)\uB85C \uB3CC\uC544\uAC00\uAE30"),
  "moreActions": "\uAE30\uD0C0 \uC561\uC158",
  "unavailable": "\uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC74C, \uC790\uC138\uD788 \uBCF4\uB824\uBA74 \uD3BC\uCE58\uAE30"
};
export { $e1819c2136902bf7$exports as default };